import React, { useState, useEffect } from 'react'
import CreateEditDesign from '@/components/HOME/create-edit-game/create-edit-design.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';

import { useNavigate } from 'react-router-dom'
import ContentManager from '@/components/SHARED/content-manager/content-manager.component';
import Modal from '@/components/modal/modal.component';
import { useSelector } from 'react-redux';
import { changeDocumentTitle } from '@/utils/useDocumentTitle';

const SettingsDesign = ({
    gameData,
    formData,
    saveData,
    saveSettings,
    cancel
}) => {

    const root = useSelector(state => state.userData.root);
    const [tempIcon, setTempIcon] = useState({});
    const [tempHeader, setTempHeader] = useState({});
    const [contentManagerElement, setContentManagerElement] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const pageTitleEl = document.getElementById('page-title');
        if (pageTitleEl) {
            pageTitleEl.innerText = 'Game Settings: Design';
        }
        changeDocumentTitle(`Settings: Game Design | Manage ${gameData.gameName ?? 'Game'}`);
    }, [gameData?.gameName]);

    function chooseElement(element) {
        let type = contentManagerElement.toLowerCase().replace('game', '')
        if (element.type === 'image') {
            document.getElementById(`selected-${type}`).classList.remove('hide');
            let obj = {
                'url': element.url.includes('https://') ? element.url : `${root}${element.url}`,
                'upload': false
            };
            if (type === 'icon') {
                setTempIcon(obj);
            } else if (type === 'header') {
                setTempHeader(obj);
            }
            console.log(obj);
            setContentManagerElement(null);
        }
    }

    return (
        <div className='settings-design'>
            <div className='g-card'>
                <BackButton cancel={cancel} />
                <div className="g-space-1"></div>
                <div className='card-title'>Settings: Game Design</div>
                <div className="g-space-1"></div>
                <div className='g-list-item grey-background'>
                    <div className="g-space-1"></div>
                    <CreateEditDesign
                        edit={true}
                        formData={formData}
                        saveData={saveData}
                        setContentManagerElement={setContentManagerElement}
                        tempIcon={tempIcon}
                        setTempIcon={setTempIcon}
                        tempHeader={tempHeader}
                        setTempHeader={setTempHeader}
                    />
                </div>
                <div className="g-space-1"></div>
                <div className='buttons'>
                    <button className='g-button' onClick={cancel}>Cancel</button>
                    <button className='g-button primary' onClick={() => saveSettings('design')}>Save Changes</button>
                </div>
            </div>
            <Modal
                show={contentManagerElement}
                cancel={() => setContentManagerElement(false)}
                closeButton={true}
                text="Content Manager"
                cls="wide" >
                <ContentManager
                    element={contentManagerElement}
                    chooseElement={chooseElement} />
            </Modal>
        </div>
    )
}

export default SettingsDesign